import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
  detailTitle: {
    color: theme.palette.darkGrey,
    fontWeight: 600,
    marginBottom: 6,
    '& span': {
      fontWeight: 400,
    },
    [theme.breakpoints.down('md')]: {
      marginBottom: 3,
    },
  },
  expired: {
    color: theme.palette.error.main,
  },
  quantityContainer: {
    display: 'flex',
    gap: 90,
    [theme.breakpoints.down('lg')]: {
      gap: 50,
    },
    [theme.breakpoints.down('md')]: {
      gap: 40,
      marginBottom: theme.spacing(1),
    },
  },
  stockItem: {
    fontSize: 18,
    fontWeight: 700,
    marginBottom: 3,
    [theme.breakpoints.down('md')]: {
      fontSize: 16,
      marginBottom: 0,
    },
  },
}));
